import React, { useContext, useReducer } from "react";
import useCBMouserOver from "../../pages/CustomHooks/useCBMouserOver";
import { DesignAssetContext } from "../../pages/CustomHooks/ContextApi";

import ACTIONS from "../../pages/DesignAssets/Design_Asset_Actions.json";
import embLabels from "../../config/emb-labels-en.json";
import MyErrorBoundary from "../../utils/ErrorBoundary";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
const LoadPvBess = ({ loadLength, configured, isEVThere }) => {
  const {
    assetDetailsReset,
    UserScope,
    callSnackbar,
    CBLoadListDispatch,
    selectedValuesHandler,
    loadConfigDataHandler,
    loadCbConfigDataHandler,
    switchboardType,
    siteType,
    loadSelectHandler,
    loadSide,
    projectKind,
    coordinates: { busbarCordinates },
   count,
   remoteMain,
   isExportOptimization,
  } = useContext(DesignAssetContext);
    const projectTypeValue = useProjectTypeValue();
  const totalCount =
    typeof loadLength === "object" && loadLength !== null ? loadLength.loadCount : loadLength || 0;
  const loadCBSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "cbLoadDetailsBlock";
      const selectedAssetValue = "selectedLoadCB";
      CBLoadListDispatch({
        type: ACTIONS.LOAD_CB_SELECT,
        payload: {
          index,
        },
      });
      selectedValuesHandler(index, selectedAssetValue, assetBlock);
      loadCbConfigDataHandler(index);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
  const  calculateXValue =(loadSide, projectKind, count)=> {
    if (loadSide === "LINE_SIDE") {
      if (projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland || projectKind?.isMgaasAnsiGrid) {
        return count.derCount === 6
          ? 0
          : count.derCount === 5 || count.derCount === 4
          ? (projectKind?.isMgaasAnsiGrid && isExportOptimization)? 140 : 40
          : (projectKind?.isMgaasAnsiGrid && isExportOptimization)? 100:(projectKind?.isMgaasAnsiGrid && !multipleLoadsAllowed && loadSide === "LINE_SIDE")? 100:50;
      } 
      if (projectKind?.isDaasIecIsland) {
        return count.derCount === 6 ? 130 :
                  count.derCount === 5 ?135 :
                  count.derCount === 4 ? 140 : 100;
      }
      if(projectKind?.isDaasAnsiIsland || projectKind?.isDaasEtoIsland  || projectKind?.isMgaasAnsiIsland){
        return count.derCount === 6 ? 130 :
               count.derCount === 5 ? projectKind?.isMgaasAnsiIsland?165:  135 :
               count.derCount === 4 ? 175 : count.derCount === 3 ?140:100;
      }
    } else {
      if (projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland || projectKind?.isMgaasAnsiGrid) {
        return count.derCount === 6 ? 130 :
               count.derCount === 5 ? 120 :
               count.derCount === 4 ?  projectKind?.isMgaasAnsiIsland? 160: (isExportOptimization && projectKind?.isMgaasAnsiGrid)?140:  100 : 100;
      } 
      if (projectKind?.isDaasIecIsland) {
        return count.derCount === 6 ? 140 :
               count.derCount === 5 ? 100 :
               count.derCount === 4 ? 140 : 100;
      }
      if(projectKind?.isDaasAnsiIsland || projectKind?.isDaasEtoIsland || projectKind?.isMgaasAnsiIsland){
        return count.derCount === 6 ? 130 :
               count.derCount === 5 ? projectKind?.isMgaasAnsiIsland?165: 135 :
               count.derCount === 4 ? 175 : count.derCount === 3 ?140: 100;
      }
    }
  }
 const multipleLoadsAllowed = siteType === "GRID_CONNECTED" && isExportOptimization && ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO"].includes(projectTypeValue);

const  calculateValue = () => {
  if (projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland) {
    if (count?.derCount === 6) {
      return count?.evCount === 1 ? 730 : 590;
    } else if (count?.derCount === 5) {
      return count?.evCount === 1 ? 630 : 580;
    } else if (count?.derCount === 4) {
      return count?.evCount === 1 ? 580 : 500;
    } else if (count?.derCount === 3) {
      return count?.evCount === 1 ? 500 : 420;
    } else {
      return 450;
    }
  } else {
    if (count?.derCount === 6) {
      return 310;
    } else if (count?.derCount === 5) {
      return 250;
    } else if (count?.derCount === 4) {
      return 200;
    } else if (projectKind?.isMgaasAnsiGrid && isExportOptimization) {
      return 130;
    } else {
      return 120;
    }
    
  }
}

const gridLimitExportOptimization  = () =>{
  if(siteType === "GRID_CONNECTED" && isExportOptimization && ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO"].includes(projectTypeValue)){
    return true;
  }if(["ISLANDABLE_GSX", "ISLANDABLE", "GRID_CONNECTED_GSX"].includes(siteType) && ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO", "DaaS ANSI","DaaS ETO","DaaS IEC"].includes(projectTypeValue)){
    return true;
  }else{
    return false;
  }
}

  return (
    <MyErrorBoundary>
      <>
        {["ISLANDABLE_GSX", "ISLANDABLE", "GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) &&
        (switchboardType === "" ||
          switchboardType === embLabels.EXISTING_SWITCHBOARD) ? (
          <svg
            className="pointer"
            x={calculateXValue(loadSide, projectKind, count)}
            y={
              projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland || projectKind?.isMgaasAnsiGrid
                ? (multipleLoadsAllowed && loadSide === "LINE_SIDE")?"-10" : (projectKind?.isMgaasAnsiGrid && !multipleLoadsAllowed && loadSide === "LINE_SIDE")? "-10":remoteMain?"82":"32"
                : loadSide === "LOAD_SIDE"
                ? (projectKind?.isDaasAnsiIsland || projectKind?.isDaasEtoIsland)
                  ? "54"
                  : projectKind?.isDaasIecIsland
                  ? "53"
                  : ( projectKind?.isDaasAnsiGrid || projectKind?.isDaasEtoGrid)?(loadSide === "LOAD_SIDE" && remoteMain)?"85":"32": "53"
                : "-8"
            }
          >
            <g id="CB1-load1">
              <svg
                width="70px"
                height={"103px"}
                viewBox="0 0 10 149"
                x={count?.derCount === 6
                  ?730
                  :count?.derCount === 5
                ?655
                :575
              }
                y={437}
                // onClick={loadCBSelectHandler}
              >
                <title>{"load Cb"}</title>
                <g
                  id="Circuit Breaker"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Circuit Breaker 1"
                    transform="translate(-651.000000, -512.000000)"
                  >
                    <g
                      id="Circuit Breaker - closed"
                      transform="translate(604.000000, 514.000000)"
                      // onMouseOver={CBMouseHandler}
                      // onMouseOut={CBMouseHandler}
                    >
                      <g
                        id="Group-15"
                        strokeWidth="4"
                        // fill={
                        //   load.CBSelected
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : mouseOverData
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : "none"
                        // }
                        // stroke={load.CBSelected ? "#42B4E6" : "none"}
                      >
                        <rect
                          id="Rectangle-Copy-20"
                          x="4"
                          y="8"
                          width="96"
                          height="124"
                        ></rect>
                        <g
                          id="Group-2"
                          transform="translate(48.000000, 0.000000)"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          strokeWidth="4"
                        >
                          <line
                            x1="0.5"
                            y1="0"
                            x2="0.5"
                            y2="47.8298611"
                            id="Line-2"
                          ></line>
                        </g>
                      </g>
                      <line
                        x1="48.5"
                        y1="97.1701389"
                        x2="48.501111"
                        y2="145"
                        id="Line-2-Copy-15"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <path
                        d="M49,48.6645651 C56.9440104,64.554855 56.9440104,80.5555556 49,96.6666667"
                        id="Path-11"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
            <g id="load11">
              <svg
                x={
                  count?.derCount === 6
                    ? 685
                    : count?.derCount === 5
                    ? 610
                    : 530
                }
                y={multipleLoadsAllowed?460:445}
                width="149px"
                height="475px"
                viewBox="0 0 90 550"
                onClick={(projectTypeValue === "DaaS ANSI")&& siteType === embLabels.GRID_CONNECTED_GSX?undefined:loadSelectHandler}
              >
                <title>load</title>
                <g
                  id="Design"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Design/Assets-_-00"
                    transform="translate(-604.000000, -372.000000)"
                  >
                    <g
                      id="SLD/Production/Uniline/Undefined"
                      transform="translate(604.000000, 372.000000)"
                    >
                      <g id="SLD/Production/Uniline/Tobedefine">
                        <g id="Group-7">
                          <rect
                            id="Rectangle"
                            x="0"
                            y="95"
                            width="96"
                            height="148"
                          ></rect>

                          <line
                            x1="48.5"
                            y1={"95"}
                            x2="48.5"
                            y2="144"
                            id="Line-2"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></line>

                          <circle
                            id="Oval"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                            strokeWidth="3"
                            cx="58"
                            cy="193.5"
                            r="45"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></circle>

                          <circle
                            id="Oval"
                            strokeWidth="3"
                            fill="var(--se-background-alternative)"
                            cx="48"
                            cy="193.5"
                            r="46.5"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></circle>

                          <text
                            id="segment_energy_infra"
                            fontFamily="se-icon"
                            fontSize="56"
                            fontWeight="normal"
                            fill="var(--se-sld-circline)"
                          >
                            <tspan x="20" y="210">
                              segment_building_small
                            </tspan>
                          </text>
                        </g>
                      </g>
                      <g
                        id="999🔒Atoms/Notifications/Done"
                        transform="translate(75.000000, 160.000000)"
                      >
                        <g
                          id="999🔒Atoms/Background/Round"
                          strokeWidth="1"
                          fillRule="evenodd"
                          fill={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          stroke="var(--se-background-alternative)"
                        >
                          <circle
                            id="Oval"
                            strokeWidth="2.66666667"
                            cx="16"
                            cy="16"
                            r={loadLength?.loadCount > 9 ? "20" : "18"}
                          ></circle>
                        </g>

                        <text
                          id="3"
                          fontFamily="Nunito-Regular, Nunito"
                          fontSize="21"
                          fontWeight="normal"
                          fill="var(--se-background-alternative)"
                        >
                          <tspan
                            x={loadLength?.loadCount < 10 ? "8" : "5"}
                            y="24"
                          >
                            {totalCount}
                          </tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
          </svg>
        ) : (
          <svg
            className="pointer"
            x={ calculateValue()}
            y={
              projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland
                ? "70"
                : ""
            }
          >
            <g id="CB1-load1">
              <svg
                width="70px"
                height={count?.evCount === 1 && projectTypeValue === "MGaaS ETO" && siteType === "ISLANDABLE"?"80px":"103px"}
                viewBox="0 0 10 149"
                x={155}
                y={300}
                // onClick={loadCBSelectHandler}
              >
                <title>{"load Cb"}</title>
                <g
                  id="Circuit Breaker"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Circuit Breaker 1"
                    transform="translate(-651.000000, -512.000000)"
                  >
                    <g
                      id="Circuit Breaker - closed"
                      transform="translate(604.000000, 514.000000)"
                      // onMouseOver={CBMouseHandler}
                      // onMouseOut={CBMouseHandler}
                    >
                      <g
                        id="Group-15"
                        strokeWidth="4"
                        // fill={
                        //   load.CBSelected
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : mouseOverData
                        //     ? "rgba(65, 181, 230, 0.35)"
                        //     : "none"
                        // }
                        // stroke={load.CBSelected ? "#42B4E6" : "none"}
                      >
                        <rect
                          id="Rectangle-Copy-20"
                          x="4"
                          y="8"
                          width="96"
                          height="124"
                        ></rect>
                        <g
                          id="Group-2"
                          transform="translate(48.000000, 0.000000)"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          strokeWidth="4"
                        >
                          <line
                            x1="0.5"
                            y1="0"
                            x2="0.5"
                            y2="47.8298611"
                            id="Line-2"
                          ></line>
                        </g>
                      </g>
                      <line
                        x1="48.5"
                        y1="97.1701389"
                        x2="48.501111"
                        y2="145"
                        id="Line-2-Copy-15"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <path
                        d="M49,48.6645651 C56.9440104,64.554855 56.9440104,80.5555556 49,96.6666667"
                        id="Path-11"
                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                        strokeWidth="4"
                        strokeLinecap="round"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
            <g id="load1">
              <svg
                x={110}
                y={ projectKind?.isMgaasIecIsland?316:(isExportOptimization && ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO"].includes(projectTypeValue))?(projectTypeValue === "MGaaS ETO" && siteType === "GRID_CONNECTED" && isExportOptimization )?313:(count?.evCount === 1 && projectTypeValue === "MGaaS ETO" && siteType === "ISLANDABLE")?298:320:298} 
                width="149px"
                height="475px"
                viewBox="0 0 90 550"
                onClick={(projectTypeValue === "DaaS ANSI")&& siteType === embLabels.GRID_CONNECTED_GSX?undefined:loadSelectHandler}
              >
                <title>load</title>
                <g
                  id="Design"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Design/Assets-_-00"
                    transform="translate(-604.000000, -372.000000)"
                  >
                    <g
                      id="SLD/Production/Uniline/Undefined"
                      transform="translate(604.000000, 372.000000)"
                    >
                      <g id="SLD/Production/Uniline/Tobedefine">
                        <g id="Group-7">
                          <rect
                            id="Rectangle"
                            x="0"
                            y="95"
                            width="96"
                            height="148"
                          ></rect>

                          <line
                            x1="48.5"
                            y1={"96"}
                            x2="48.5"
                            y2="144"
                            id="Line-2"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></line>

                          <circle
                            id="Oval"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                            strokeWidth="3"
                            cx={!gridLimitExportOptimization()?"50":"58"}
                            cy={!gridLimitExportOptimization()?"190":"193.5"}
                            r="45"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill=""
                          ></circle>

                        { gridLimitExportOptimization() && <circle
                            id="Oval"
                            strokeWidth="3"
                            fill="var(--se-background-alternative)"
                            cx="48"
                            cy="193.5"
                            r="46.5"
                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                          ></circle>
}
                          <text
                            id="segment_energy_infra"
                            fontFamily="se-icon"
                            fontSize="56"
                            fontWeight="normal"
                            fill="var(--se-sld-circline)"
                          >
                            <tspan x="20" y="210">
                              segment_building_small
                            </tspan>
                          </text>
                        </g>
                     { gridLimitExportOptimization() && <g
                          id="999🔒Atoms/Notifications/Done"
                          transform="translate(75.000000, 160.000000)"
                        >
                          <g
                            id="999🔒Atoms/Background/Round"
                            strokeWidth="1"
                            fillRule="evenodd"
                            fill={configured ? "var(--se-sld-circline)" : "#E47F00"}
                            stroke="var(--se-background-alternative)"
                          >
                            <circle
                              id="Oval"
                              strokeWidth="2.66666667"
                              cx="16"
                              cy="16"
                              r={loadLength?.loadCount > 9 ? "20" : "18"}
                            ></circle>
                          </g>

                          <text
                            id="3"
                            fontFamily="Nunito-Regular, Nunito"
                            fontSize="21"
                            fontWeight="normal"
                            fill="var(--se-background-alternative)"
                          >
                            <tspan
                              x={loadLength?.loadCount < 10 ? "8" : "5"}
                              y="24"
                            >
                              {totalCount}
                            </tspan>
                          </text>
                        </g>}
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </g>
          </svg>
        )}
      </>
    </MyErrorBoundary>
  );
};

export default LoadPvBess;
